import React, {
    useEffect,
    useState,
    useRef,
    createContext,
    useContext,
  } from "react";
  import { motion, useInView } from "framer-motion";
  import { useTranslation } from "react-i18next";


  type LinksContextType = {
    lastVisible: string | null;
    setLastVisible: (id: string) => void;
    hoveredId: string | null;
    setHoveredId: (id: string | null) => void;
  };
  const LinksContext = createContext<LinksContextType | null>(null);
  interface AnimatedLinkProps {
    href: string;
    children: React.ReactNode;
    delay: number;
    id: string;
  }
  const AnimatedLink = ({ href, children, delay, id }: AnimatedLinkProps) => {
    const { lastVisible, setLastVisible, hoveredId, setHoveredId } =
      useContext(LinksContext)!;
    const ref = useRef(null);
    const isInView = useInView(ref, {
      margin: "-20%",
    });
    useEffect(() => {
      if (isInView) {
        setLastVisible(id);
      }
    }, [isInView, id, setLastVisible]);
    const isActive = hoveredId ? hoveredId === id : lastVisible === id;
    return (
      <motion.div
        ref={ref}
        initial={{
          opacity: 0,
          y: 20,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        exit={{
          opacity: 0,
          y: -20,
        }}
        viewport={{
          once: false,
          margin: "-20%",
        }}
        transition={{
          duration: 0.5,
          delay,
        }}
      >
        <a
          href={href}
          className={`LPanimated-link ${isActive ? "LPactive" : ""} ${lastVisible === id ? "LPlast-visible" : ""}`}
          onMouseEnter={() => setHoveredId(id)}
          onMouseLeave={() => setHoveredId(null)}
        >
          {children}
        </a>
      </motion.div>
    );
  };
 const LandingPageLinks = () =>  {
    const { t } = useTranslation();
    const [lastVisible, setLastVisible] = useState<string | null>(null);
    const [hoveredId, setHoveredId] = useState<string | null>(null);
    return (
      <>
        <style>
          {`
            .LPcontainer {
              width: 100%;
              background-color: white;
              padding-bottom: 5rem;
            }
            .LPlinks-wrapper {
              width: 100%;
              padding-top: 8rem;
              
            }
              @media screen and (min-width: 1024px){
              .LPlinks-wrapper {
                margin-left: 3rem;
              }
              }
            .LPanimated-link {
              display: block;
              font-size: 2.5rem;
              font-weight: 700;
              padding: 0.75rem 1.5rem;
              color: #9CA3AF;
              transition: color 0.3s ease;
              text-decoration: none;
              line-height: 1.1;
              cursor: pointer !important;
            }
            /* Mobile and Tablet styles - active state based on last visible */
            @media (max-width: 1023px) {
              .LPanimated-link.LPlast-visible {
                color: black;
              }
              /* Disable hover effects on mobile and tablet */
              .LPanimated-link.active:not(.LPlast-visible) {
                color: #9CA3AF;
              }
            }
            /* Desktop styles - active state based on hover */
            @media (min-width: 1024px) {
              .LPanimated-link {
                font-size: 4.5rem;
              }
              .LPanimated-link.LPactive {
                color: black;
              }
              .LPanimated-link.LPlast-visible:not(.LPactive) {
                color: #9CA3AF;
              }
            }
              .LP-title {
              padding: 2rem;
              font-size: smaller;
              }
          `}
        </style>
        <div className="LPcontainer">
          <LinksContext.Provider
            value={{
              lastVisible,
              setLastVisible,
              hoveredId,
              setHoveredId,
            }}
          >
            <div className="LPlinks-wrapper">
                <p className="LP-title">{t('weMake')}:</p>
                <AnimatedLink href="/#" delay={0.1} id="link1">
              {t('interior')}
              </AnimatedLink>
              <AnimatedLink href="/#" delay={0.2} id="link2">
              {t('renovation')}
              </AnimatedLink>
              <AnimatedLink href="/#" delay={0.4} id="link4">
                {t('furnitureDesign')}
              </AnimatedLink>
           
               {/* <Link href="/websites">Websites</Link>
            <Link href="/archiapp">archi app</Link>
            <Link href="/interior">Interior</Link>
            <Link href="/books">Books</Link>
            <Link href="/photography">Photography</Link> */}
            </div>
          </LinksContext.Provider>
        </div>
      </>
    );
  }

  export default LandingPageLinks;
  